export default "__VITE_ASSET__B$beAyCA__"